import { UITheme, UIThemes } from '@agilox/ui-common';

export interface ButtonSpinnerConfig {
	inverted: boolean;
	color: UITheme;
}

interface ButtonSpinnerState {
	default: ButtonSpinnerConfig;
	hover: ButtonSpinnerConfig;
}

export const BUTTON_SPINNER_CONFIG: Record<string, ButtonSpinnerState> = {
	[UIThemes.Primary]: {
		default: { inverted: true, color: UIThemes.Primary },
		hover: { inverted: true, color: UIThemes.Primary },
	},
	[UIThemes.Secondary]: {
		default: { inverted: false, color: UIThemes.Primary },
		hover: { inverted: true, color: UIThemes.Primary },
	},
	[UIThemes.Dark]: {
		default: { inverted: true, color: UIThemes.Dark },
		hover: { inverted: true, color: UIThemes.Dark },
	},
	[UIThemes.Blue]: {
		default: { inverted: true, color: UIThemes.Blue },
		hover: { inverted: true, color: UIThemes.Blue },
	},
	[UIThemes.Red]: {
		default: { inverted: true, color: UIThemes.Red },
		hover: { inverted: true, color: UIThemes.Red },
	},
};
